export const Badge = ({ children, className, ...rest }) => {
  return (
    <div
      className={`flex-none px-6 py-1 capitalize rounded-full cursor-pointer ${className}`}
      {...rest}
    >
      {children}
    </div>
  )
}
